var icon = require('vue-svgicon')
icon.register({
  'ks-icon-ach': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M18 96h92v14H18zM42 90.03L41.89 56H28l-.11 34 14.11.03zM71 90.03L70.89 56H57l-.11 34 14.11.03zM100 90.03L99.89 56H86l-.11 34 14.11.03zM18 51h92l-.03-9.98L64 17 18.11 40.9 18 51z"/>'
  }
})
